import classNames from 'classnames';
import * as React from 'react';

type Props = React.ComponentProps<'i'> & {
  cardType: string;
};

const cards: { [key: string]: string } = {
  'American Express': 'fa-cc-amex',
  Discover: 'fa-cc-discover',
  Mastercard: 'fa-cc-mastercard',
  MasterCard: 'fa-cc-mastercard',
  Visa: 'fa-cc-visa',
};

const defaultIcon = 'fa-credit-card-alt';

/**
 * Renders the logo for the given card type. A generic card icon is displayed if
 * an unknown card type is provided.
 */
export const CreditCardLogo = ({ cardType, className, ...props }: Props) => (
  <i
    className={classNames(
      className,
      'braintree-credit-card-logo',
      'fa',
      cards[cardType] || defaultIcon,
    )}
    {...props}
  />
);
